module.exports = __webpack_public_path__ + "static/media/exit-icon.6f721ee9.svg";